import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { prettifyAppName } from '../../../utils/general';
import { CoHostTooltipWrapper } from './CoHostTooltip.style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CoHostTooltip({
  children,
  open,
  closeHandler,
  participantName,
  appName
}) {
  return /*#__PURE__*/_jsx(CoHostTooltipWrapper, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      open: open,
      use: "longform",
      placement: "bottom",
      title: /*#__PURE__*/_jsxs(TFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsxs(TFlex, {
          justify: "between",
          children: [/*#__PURE__*/_jsx(H4, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "notifications.coHostRequestTooltipTitle"
            })
          }), /*#__PURE__*/_jsx(CloseButton, {
            color: "icon-core-subtle",
            onClick: closeHandler,
            "data-test-id": `${appName}-request-co-host-notification-tooltip-close-button`
          })]
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "notifications.coHostRequestTooltipText",
          options: {
            name: participantName,
            appName: prettifyAppName(appName)
          }
        })]
      }),
      children: children
    })
  });
}
export default CoHostTooltip;